angular.module('impactx.approval').component('ixCateringApprovalItem', {
    bindings: {
        item: '<',
        showComments: '=',
        selectedItems: '=',
        trns: '<',
        showNet: '<',
        showGross: '<',
        showCatalogNet: '<',
        markAsChanged: '&',
        readOnly: '<'
    },
    templateUrl: 'modules/approval/templates/cateringapproval-item.tmpl.html',
    controller: function () {
        var ctrl = this;
        ctrl.selectItem = function (item, event) {
            if (!ctrl.readOnly) {
                if (event.target.tagName != "INPUT" && (event.target.parentNode == null || event.target.parentNode.tagName != "BUTTON")
                    && event.target.tagName != "BUTTON" && event.target.tagName != "TEXTAREA"
                    && event.target.tagName != "MD-SELECT"
                    && event.target.getAttribute("role") != "button") {
                    if (ctrl.showComments) {
                        ctrl.showComments.value = false;
                    }
                    if (item.selected) {
                        var index = ctrl.selectedItems.indexOf(item);
                        if (index > -1) {
                            ctrl.selectedItems.splice(index, 1);
                        }
                    }
                    else {
                        ctrl.selectedItems.push(item);
                    }
                    item.selected = !item.selected;
                }
            }
        };
    }
});